import { DatePicker } from '../../../DateTime'
import { Control } from '../Control'

function ControlDate({ value, onChange, ...controlProps }) {
  function handleChange(nextValue) {
    onChange(value, { value: nextValue })
  }

  return (
    <Control {...controlProps} value={value} onChange={onChange}>
      <DatePicker
        borderless
        clearable={true}
        disabled={value.omitted}
        value={value.value ?? null}
        onChange={handleChange}
      />
    </Control>
  )
}

export default ControlDate
